/* unplugin-vue-components disabled */import { render } from "./w-tree-select.vue?vue&type=template&id=303b7496&ts=true"
import script from "./w-tree-select.vue?vue&type=script&lang=ts"
export * from "./w-tree-select.vue?vue&type=script&lang=ts"

import "./w-tree-select.vue?vue&type=style&index=0&id=303b7496&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__